import React from 'react';
import PageLayout from '../components/common/PageLayout';
import CustomerList from '../components/CustomerList';

const CustomerListPage = () => (
  <PageLayout
    title="Customer List"
    showCustomerSectionTabs
    showBreadcrumbs={false}
    navLinks={[
      { url: '/finance/rates/', label: 'Manage Rate' },
    ]}
  >
    <CustomerList />
  </PageLayout>
);

export default CustomerListPage;
